<template>
  <section class="d-flex md-elevation-5" @click="$emit('handleClick')" id="btn-start-screen">
    <div class="icn">
      <i class="material-icons">keyboard_arrow_left</i>
    </div>
    <div class="txt">
      <h3 class="text-uppercase font-weight-bold">{{ text }}</h3>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'BtnStartScreen',
    props: {
      text: { type: String, default: 'text' }
    }
  }
</script>

<style scoped lang="scss">

  $percent-icn: 15%;

  #btn-start-screen {
    background-color: rgba(144, 0, 0, 0.90);
    height: 4em;
    transition: 350ms;
    user-select: none;
    // border: 1px solid #fff;
    overflow: hidden;
    cursor: pointer;
    color: white;
    box-shadow: 2px 2px 0 white;
  }

  .icn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: $percent-icn;
    > i {
      transition: 350ms;
      padding-left: 18px;
      font-size: 3rem;
    }
  }

  .txt {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100% - $percent-icn;
    height: 100%;
    > h3 {
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
      margin: 0;
      font-size: 1.2rem;
    }
  }

  #btn-start-screen:hover {
    background-color: rgba(223, 0, 0, 0.95);
    box-shadow: 4px 4px 0 white;
    .icn > i {
      padding-left: 0;
    }
  }
</style>
